import { SOCKET_MESSAGE_TYPE } from '@/constants/socketMessage';

/**
 * SocketMessage Class.
 *
 * @typedef {Object} SocketMessage
 *
 * @module SocketMessage
 **/
export default class SocketMessage {

  /**
   * @constructor
   * @this {SocketMessage}
   *
   * @param {Object} RawSocketMessage - Socket Message information.
   **/
  constructor({ userId, sessionId, number, message, messageType, authenticated, succeeded }) {
    // Message update
    this.userId = userId;
    this.sessionId = sessionId;
    this.number = number;
    this.message = message;
    this.messageType = messageType;

    // Auth Challenge/Response
    this.authenticated = authenticated;
    this.messageType = messageType;
    this.succeeded = !!succeeded;
  }

  /**
   * Determines whether current socket message type is an 'authChallenge' or not,
   * returning true or false as appropriate.
   *
   * @returns {Boolean}
   */
  get isAuthChallenge() {
    return this.messageType === SOCKET_MESSAGE_TYPE.authChallenge;
  }

  /**
   * Determines whether current socket message type is an 'authResponse' or not,
   * returning true or false as appropriate.
   *
   * @returns {Boolean}
   */
  get isAuthResponse() {
    return this.messageType === SOCKET_MESSAGE_TYPE.authResponse;
  }

  /**
   * Determines whether current socket message type is a 'subscriptionResponse' or not,
   * returning true or false as appropriate.
   *
   * @returns {Boolean}
   */
  get isSubscriptionResponse() {
    return this.messageType === SOCKET_MESSAGE_TYPE.subscriptionResponse;
  }

  /**
   * Determines whether current socket message type is a 'messageUpdate' or not,
   * returning true or false as appropriate.
   *
   * @returns {Boolean}
   */
  get isMessageUpdate() {
    return this.messageType === SOCKET_MESSAGE_TYPE.messageUpdate;
  }

  get isFlowUpdate() {
    return this.messageType === SOCKET_MESSAGE_TYPE.flowUpdate;
  }
}
